import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { EarhivUiComponents } from '@app/shared/models/earhiv-ui-components';
import {
  FilterView,
  FilterViewProviderDirective,
  NtapCommonComponent
} from '@ntap/core';
import { KlasaHierarchyListViewProviderDirective } from './providers/klasa-hierarchy-list-view-provider';

@Component({
  selector: 'app-klasa-list',
  templateUrl: './klasa-list.component.html'
})
export class KlasaListComponent
  extends NtapCommonComponent
  implements OnInit, AfterViewInit
{
  INIT_COMP_ID = EarhivUiComponents.TREELISTVIEW;
  KLASA_VIEW_NAME = 'seup.klasa';

  currentViewName: string;
  currentViewState: object | null = null;
  currentViewStateFilter: object = {};
  currentViewClass: string;

  @ViewChild(FilterViewProviderDirective)
  filterViewProviderDirective: FilterViewProviderDirective<FilterView>;

  constructor(
    protected listViewProvider: KlasaHierarchyListViewProviderDirective
  ) {
    super();
  }

  ngOnInit() {
    this.currentViewName = this.KLASA_VIEW_NAME;
    this.currentViewState = {};
    this.currentViewStateFilter = {};
    this.currentViewClass = 'list-view-' + this.KLASA_VIEW_NAME;
  }

  ngAfterViewInit(): void {
    if (this.filterViewProviderDirective) {
      this.addSubscription(
        this.filterViewProviderDirective.viewData$.subscribe(
          (filterState: any) => {
            this.currentViewState = Object.assign({}, filterState);
          }
        )
      );
    }
  }
}
